
const formatPortfolio = function(portfolio) {
    const { id, name, blockchains, categories } = portfolio;
    return {
      id,
      name,
      assets: portfolio.assets.map((row) => row.id) || [],
      blockchains,
      categories,
    };
  };
  
  
  export { formatPortfolio };
  
  